import { IMappers } from '../../../repositories/coworking/v1/is-operator';
import { IApplicationContext } from '../../../types/applicationContext';

export enum EIsOperatorStatus {
  CriticalError,
  Error,
  Pending,
  Success,
}

export interface IIsOperatorResult {
  isOperator: boolean | null;
  message: string | null;
  status: EIsOperatorStatus;
}

export type IsOperatorDependencies = Pick<IApplicationContext, 'logger' | 'httpApi'>;

export type IsOperatorMappers = IMappers<IIsOperatorResult, IIsOperatorResult>;
